/** Stable marker for verify skills (no visual change). Values name the loader in failure messages. */
export const VERIFY_LOADING_ATTR = 'data-cw-verify-loader'

export const VERIFY_LOADER_KIND = {
  spinner: 'spinner',
  smallSpinner: 'small-spinner',
  skeleton: 'skeleton',
  suspenseFallback: 'suspense-fallback',
  skeletonAppFallback: 'skeleton-app-fallback',
  web3Gate: 'web3-gate',
} as const
